import PersonalizedTakeawaysPage from '../components/personalized-takeaways-page';

export default class PersonalizedTakeawaysReactCtrl {
  /* @ngInject */
  constructor(
    $scope,
  ) {
    $scope.PersonalizedTakeawaysPage = PersonalizedTakeawaysPage;
  }
}
